import { Component, OnInit,Input,Output, EventEmitter } from '@angular/core';
import { Screenshot } from '../../models/screenshot';
import { SCREENSHOT_PATH } from 'src/app/shared/constants/screenshots.constant';

import Swal from 'sweetalert2'
import { ScreenshotService } from '../../services/screenshot.service';

@Component({
  selector: 'app-screenshot-view',
  templateUrl: './screenshot-view.component.html',
  styleUrls: ['./screenshot-view.component.css']
})
export class ScreenshotViewComponent implements OnInit {

  @Input("SceenshotDataSource") sceenshotDataSource:Screenshot;

  @Output() refreshData = new EventEmitter<string>();

  public SCREENSHOT_PATH = SCREENSHOT_PATH;

  public id:string = "";

  constructor(private screenshotService:ScreenshotService) { }

  ngOnInit(): void {
    // console.log(this.sceenshotDataSource)
  }

  confirm(id:string):void{
    this.id = id;
    Swal.fire({
      title: 'Are you sure you want to delete?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.delete();
      }
    })
  }

  delete():void{
    console.log(this.id);
    this.screenshotService.deleteScreenshot(this.id).subscribe(
      (res:any) => {
        
        Swal.fire({
          icon: res.status,
          title: res.status,
          text: res.message,
        });

        this.refreshScreenshots();
      },
      (err)=>{
        console.log(err);
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something went wrong! Please try again later.',
        });
      }
    )
  }

  refreshScreenshots(){
    this.refreshData.emit('');
  }

}
